import React, { useState, useEffect } from "react";
import ModalNew from "./Modal";
import LoadingPlaceholder from "../loading/LoadingPlaceholder";

/**
 * Reusable modal component for API response feedback
 * Handles loading, success, and error states with consistent messaging
 */
const ApiResponseModal = ({
  isOpen,
  isLoading,
  isSuccess,
  message,
  onClose,
  onRetry,
  className = "api-response-modal",
  successButtonText = "OK",
  retryButtonText = "Try Again",
  closeButtonText = "OK",
}) => {
  const [showLoading, setShowLoading] = useState(false);

  // Ensure loading shows for minimum 1000ms for testing
  useEffect(() => {
    if (isLoading) {
      setShowLoading(true);
    } else {
      // Add delay when loading stops to ensure we can see the loading state
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!isOpen) return null;

  // Dynamic className based on state
  const modalClassName = [
    className,
    !isLoading && isSuccess && "success",
    !isLoading && !isSuccess && "error",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ModalNew className={modalClassName}>
      <div className="modal-form">
        {showLoading ? (
          <div className="loading-container">
            <LoadingPlaceholder type="text" />
            <LoadingPlaceholder type="line" />
          </div>
        ) : (
          <>
            <div className="result-content" style={{ textAlign: "center" }}>
              <p>{message}</p>
            </div>
            <div
              className="modal-actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              {isSuccess ? (
                <button
                  className="cta-button primary short text-center"
                  onClick={onClose}
                >
                  {successButtonText}
                </button>
              ) : (
                <>
                  {typeof onRetry === "function" && (
                    <button
                      className="cta-button secondary short text-center"
                      onClick={onRetry}
                    >
                      {retryButtonText}
                    </button>
                  )}
                  <button
                    className="cta-button primary short text-center"
                    onClick={onClose}
                  >
                    {closeButtonText}
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </ModalNew>
  );
};

export default ApiResponseModal;
